// Component for displaying and managing user's account details
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';

const MyAccount = ({ setIsSignedIn }) => {
    const [user, setUser] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('http://localhost:3000/api/users/me', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUser(); // Fetch user data on component load
    }, []);

    const handleDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.delete('http://localhost:3000/api/users/me', {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log(response.data);
            localStorage.removeItem('token');
            setIsSignedIn(false); // Update sign-in status
            navigate('/signup'); // Redirect to signup page
        } catch (error) {
            console.error('Error deleting account:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <div className="my-account-container">
            <div className="account-card">
                <div className="profile-picture">
                    <img src={user.profile_picture_url} width="200"/>
                </div>
                <div className="user-details">
                    <p><strong>Full Name: </strong>{user.name} {user.surname}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    {user.age && <p><strong>Age:</strong> {user.age}</p>}
                    {user.favorite_colors && user.favorite_colors.length > 0 && (
                        <p><strong>Favorite Color\-s:</strong> {user.favorite_colors.join(', ')}</p>
                    )}

                    <div className="account-actions">
                        <button className="edit-btn" onClick={() => navigate('/edit-my-account')}><i class="fa-solid fa-pencil"></i><strong>𝐸𝒹𝒾𝓉</strong></button>
                        <button className="delete-btn" onClick={handleDelete}><i class="fa-solid fa-trash"></i><strong>𝒟𝑒𝓁𝑒𝓉𝑒 𝒜𝒸𝒸𝑜𝓊𝓃𝓉</strong></button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyAccount;